import { render, staticRenderFns } from "./desselects.vue?vue&type=template&id=7bd6d07a"
import script from "./desselects.vue?vue&type=script&lang=js"
export * from "./desselects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports